import { FieldMetaProps } from 'formik';

export const getFieldError = <TValues = unknown>(
  fieldMeta: FieldMetaProps<TValues>,
  submitCount: number,
): string | undefined => {
  return submitCount > 0 || fieldMeta.touched ? fieldMeta.error : undefined;
};
